// extracted by mini-css-extract-plugin
export default {"Blackberry":"#333D47","ScreenXSMax":"(max-width: 767px)","pricingContainer":"Gbba134","fullPrice":"G0d04c9 G9fa6b0 G81a5ae Gd6846a Gddfcfd","total":"G4fe343 Ge2e370 Gddfcfd G66772c"};